import Styles from './styles.module.css';
import React, { useState } from 'react';
import DefaultInput1 from '../../../package/1-input/index';
import { doc, getFirestore, updateDoc } from 'firebase/firestore';
import { useAppSelector } from 'src/salon/app/hook';

type SettingMailsProps = {
  mailAddress: string;
  setMail: React.Dispatch<React.SetStateAction<boolean>>;
};

// 全角の英数字・記号(＠ など)を半角にし、前後の空白を除く。
// 全角の「＠」のまま保存されると、通知メールが届かない(実際に1社あった)。
function normalizeMail(value: string): string {
  return value
    .replace(/[！-～]/g, (c) => String.fromCharCode(c.charCodeAt(0) - 0xFEE0))
    .replace(/\u3000/g, ' ')
    .trim();
}

const MAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

const SettingMails: React.FC<SettingMailsProps> = ({ mailAddress, setMail }) => {

  const company = useAppSelector((state) => state.company.company);

  const [ address, setAddress ] = useState<string>(mailAddress);
  const [ hintText, setHintText ] = useState<any>({ title: "", desc: "" });
  const [ invalid, setInvalid ] = useState(false);

  function check() {
    const normalized = normalizeMail(address);
    if (normalized === '') return;
    if (!MAIL_PATTERN.test(normalized)) {
      setInvalid(true);
      return;
    }
    setInvalid(false);
    invite(normalized);
  }

  async function invite(mail: string) {
    const db = getFirestore();
    const companyRef = doc(db, "companies", company.id);

    await updateDoc(companyRef, {
      "notification.mail": mail,
    }).then(() => {
      setMail(false);
    });
  }

  return (
    <div className={Styles.overlay}>
      <div className={Styles.scrim} onClick={() => setMail(false)}></div>
      <div className={Styles.card}>

        <div className={Styles.header}>
          <h3 className={Styles.headerTitle}>通知先アドレス</h3>
          <button type="button" className={Styles.saveBtn} onClick={() => check()}>保存</button>
        </div>

        <div className={Styles.body}>
          <DefaultInput1
            error={invalid}
            title={'メールアドレス'} length={40} place={'memorii-works@trankllc.com'} value={address} setValue={setAddress}
            desc={invalid ? '※メールアドレスの形式が正しくありません。入力内容をご確認ください。' : '※メールアドレスを入力してください。'} hint={{ title: "", desc: "" }} setHintText={setHintText} />
        </div>

      </div>
    </div>
  );
}

export default SettingMails;
